import { createAsyncThunk } from '@reduxjs/toolkit';
import type ApplicationApi from 'api/digifi/application/ApplicationApi';
import { ActionType } from 'enums/ActionType';

export const createGetApplicationStepThunk = (api: ApplicationApi) => {
  return createAsyncThunk(ActionType.FetchApplicationStep, async (applicationId: string) => {
    return await api.getApplicationStep(applicationId);
  });
};
